import script from "./hisWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./hisWrapper.vue?vue&type=script&setup=true&lang=js"

import "./hisWrapper.vue?vue&type=style&index=0&id=6aa97526&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa97526"]])

export default __exports__